const devBaseUrl = 'https://static.devfdg.net/static/images/fiat';
const prodBaseUrl = 'https://static.binance.us/static/images/fiat';
const env = process.env.BUILD_ENV;
const defaultIsProd = env === 'production';
function getImage(path, isProd = defaultIsProd) {
  const baseUrl = isProd ? prodBaseUrl : devBaseUrl;
  return `${baseUrl}/${path}`;
}
export { getImage as default };
